import { ExternalLink } from "./components/ExternalLink";
import { PhotonStats } from "./PhotonStats";
import { SOCIALS_LINKS } from "./config/links";
import { SOCIAL_ICONS } from "./config/images";
import { VoteWitness } from "./VoteWitness";
import { useState } from "react";
import './Footer.scss';

const CLOSE_EXPANDED_SOCIALS_AFTER_SEC = 10;


export const Footer = ({ addMsg, voter }) => {
  const [socialsExpanded, setSocialsExpanded] = useState(false);
  const [showMoreSocials, setShowMoreSocials] = useState(false);

  const showDetails = () => {
    setSocialsExpanded(true);
    setTimeout(() => {
      setSocialsExpanded(false);
      setShowMoreSocials(false);
    }, CLOSE_EXPANDED_SOCIALS_AFTER_SEC * 1000);
  };

  const Socials = () => {
    return (
      <div className="socials-details">
        <ExternalLink id="discord" href={SOCIALS_LINKS.DISCORD}>
          <img className="icon" src={SOCIAL_ICONS.DISCORD} alt="discord-link" />
        </ExternalLink>
        <ExternalLink id="twitter" href={SOCIALS_LINKS.TWITTER}>
          <img className="icon" src={SOCIAL_ICONS.TWITTER} alt="twitter-link" />
        </ExternalLink>
        <ExternalLink id="website" href={SOCIALS_LINKS.WEBSITE}>
          <img className="icon" src={SOCIAL_ICONS.WEBSITE} alt="website-link" />
        </ExternalLink>
        <ExternalLink id="website" href={SOCIALS_LINKS.HIVE_BLOG}>
          <img className="icon" src={SOCIAL_ICONS.HIVE_BLOG} alt="website-link" />
        </ExternalLink>

        {!showMoreSocials
          ? <span className="more-socials" onClick={() => setShowMoreSocials(true)}>More...</span>
          : <div className="more-socials">
              <ExternalLink id="website" href={SOCIALS_LINKS.INSTAGRAM}>
                <img className="icon" src={SOCIAL_ICONS.INSTAGRAM} alt="instagram-link" />
              </ExternalLink>
              <ExternalLink id="website" href={SOCIALS_LINKS.YOUTUBE}>
                <img className="icon" src={SOCIAL_ICONS.YOUTUBE} alt="youtube-link" />
              </ExternalLink>
              <ExternalLink id="website" href={SOCIALS_LINKS.TIKTOK}>
                <img className="icon" src={SOCIAL_ICONS.TIKTOK} alt="tiktok-link" />
              </ExternalLink>
              <ExternalLink id="website" href={SOCIALS_LINKS.FACEBOOK}>
                <img className="icon" src={SOCIAL_ICONS.FACEBOOK} alt="facebook-link" />
              </ExternalLink>
            </div>
        }
      </div>
    );
  };

  return (
    <div className="footer">
      <div id="socials">
        {!socialsExpanded
          ? <div onClick={showDetails}>
              <img
              className="icon group"
              src={SOCIAL_ICONS.GROUP}
              alt="socials-links"
            />
            </div>
          : <Socials/>
        }
      </div>

      <div id="photon">
        {!socialsExpanded && <PhotonStats {...{ addMsg }} />}
      </div>

      <div id="witness">
        {!socialsExpanded && <VoteWitness voter={voter}/>}
      </div>
    </div>
  );
};
